module.exports = __webpack_public_path__ + "static/man-1c7e1d2410ddaa7af3a596bf7c92094c.png";